import Papa from 'papaparse'

export const BULK_RELEASE_MAX_ROWS = 500

export const BULK_RELEASE_MAX_CSV_SIZE_BYTES = 2 * 1024 * 1024

export const BULK_RELEASE_ID_HEADER = 'validationSubmissionId'

export type ParsedBulkReleaseCsv = {
  ids: string[]
  hasIdHeader: boolean
  duplicateCount: number
}

// Other columns are ignored, as the endpoint ignores them, so the held submissions export uploads as it is.
export function parseBulkReleaseCsv(csvText: string): ParsedBulkReleaseCsv {
  const { data, meta } = Papa.parse<Record<string, string>>(csvText, {
    header: true,
    skipEmptyLines: true,
    transformHeader: header => header.trim()
  })

  if (!(meta.fields ?? []).includes(BULK_RELEASE_ID_HEADER)) {
    return { ids: [], hasIdHeader: false, duplicateCount: 0 }
  }

  const rowIds = data.map(row => row[BULK_RELEASE_ID_HEADER]?.trim() ?? '').filter(Boolean)
  const ids = [...new Set(rowIds)]

  return { ids, hasIdHeader: true, duplicateCount: rowIds.length - ids.length }
}
